<template>
  <RevBreadcrumb
    v-if="links.length"
    :ariaLabel="i18n(translations.breadcrumb)"
    :breads="links"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevBreadcrumb } from '@ds/components/Breadcrumb'

import translations from './Breadcrumb.translations'

const props = defineProps<{
  breads: { label: string; url: string }[]
  trackingZone: string
}>()

const i18n = useI18n()

const links = computed(() => {
  if (isEmpty(props.breads)) {
    return []
  }

  return props.breads.map(({ label, url }, index) => ({
    title: label,
    link: url,
    tracking: {
      zone: props.trackingZone,
      value: 'breadcrumb',
      name: label,
      position: `breadcrumb_${index + 1}`,
    },
  }))
})
</script>
